<template>
  <div>
    <div id="card-element"></div>
    <div id="card-errors" role="alert" ref="error"></div>
  </div>
</template>
<script>
export default {
  emits: ["validate"],
  data() {
    return {
      card: null,
      valid: false
    }
  },
  mounted() {
    this.loadStripeElement()
  },
  methods: {
    loadStripeElement() {
      this.card = this.stripe.elements().create("card", {
        classes: {
          base: "w-full py-4 px-4 border border-brand-mid-gray shadow rounded placeholder-brand-mid-gray text-brand-black",
          focus: "!border-brand-green !ring-brand-green",
          complete: "bg-brand-background-light-gray"
        }
      })
      this.card.mount("#card-element")
      const that = this

      this.card.on("change", (event) => {
        if (event.complete) {
          that.valid = true
          that.$emit("validate")
        }
      })
    }
  }
}
</script>
